import React, { ChangeEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import FooterActions from "./AssignBuildingFooter";
import HeaderBreadCrumb from "./AssignBuildingHeader";
import "./AssignBuilding.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isRtl, getTextValueById } from "src/utils/helpers";
import AssignBuildingTitle from "./AssignBuildingTitle";

const Details = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(["common", "assignBuilding"]);

  const citiesOptions = useSelector((state: any) => state.lookup.citiesOptions);
  const emirateOptions = useSelector(
    (state: any) => state.lookup.emiratesOptions
  );
  const serviceTerritories = useSelector(
    (state: any) => state.lookup.allServiceTerritories
  );

  function getEmirate(id: any) {
    return getTextValueById(id, emirateOptions, "emirateId");
  }

  function getServiceTerritory(id: any) {
    return getTextValueById(id, serviceTerritories, "territoryId");
  }

  function getCity(id: any) {
    return getTextValueById(id, citiesOptions, "cityId");
  }

  var assignBuilding = useSelector((state: any) => state.assignBuilding);
  var [buildingDetails, setBuildingDetails] = useState(
    assignBuilding.buildingInfo ? assignBuilding.buildingInfo : {}
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    buildingDetails = JSON.parse(JSON.stringify(buildingDetails));
    buildingDetails[e.target.name] = e.target.value;
    setBuildingDetails(buildingDetails);
  };

  return (
    <>
      <AssignBuildingTitle  />
      <HeaderBreadCrumb></HeaderBreadCrumb>
      <h1 className="text-center m-auto">{t("buildingInfo")}</h1>
      <div className="registration-form-wrapper assign-form-wrapper">
        <div className="registration-form building-details-form">
          <div className="building-details-form__content">
            <div className="form-group-row ">
              <div className="form-group">
                <label htmlFor="propertyId">{t("propertyID")}</label>
                <input
                  type="text"
                  id="propertyId"
                  name="propertyId"
                  disabled={true}
                  onChange={handleChange}
                  value={buildingDetails?.propertyNumber}
                />
              </div>
              <div className="form-group">
                <label htmlFor="Name">{t("buildingName")}</label>
                <input
                  type="text"
                  disabled={true}
                  id="Name"
                  onChange={handleChange}
                  name="Name"
                  value={buildingDetails?.name}
                />
              </div>
            </div>
            <div className="form-group-row d-flex flex-column g-1">
              <h4>{t("addressInfo")}</h4>
              <div className="form-group">
                <label htmlFor="address1_Name" className="me-2">
                  {t("address1")}{" "}
                </label>
                <input
                  type="text"
                  disabled={true}
                  id="address1_Name"
                  name="address1_Name"
                  onChange={handleChange}
                  value={buildingDetails?.address1_Name}
                  placeholder="Property name address goes here"
                />
              </div>
            </div>
            <div className="form-group-row ">
              <div className="form-group">
                <label htmlFor="address1_Longitude">{t("longitude")}</label>
                <input
                  type="text"
                  disabled={true}
                  id="address1_Longitude"
                  name="address1_Longitude"
                  onChange={handleChange}
                  value={buildingDetails?.address1_Longitude || ""}
                />
              </div>
              <div className="form-group">
                <label htmlFor="address1_Latitude">{t("latitude")}</label>
                <input
                  type="text"
                  disabled={true}
                  id="address1_Latitude"
                  name="address1_Latitude"
                  onChange={handleChange}
                  value={buildingDetails?.address1_Latitude || ""}
                />
              </div>
            </div>
            <div className="form-group-row service-location ">
              <div className="form-group">
                <label htmlFor="emirate">{t("emirate")}</label>
                <input
                  type="text"
                  disabled={true}
                  id="emirate"
                  name="emirate"
                  onChange={handleChange}
                  value={getEmirate(buildingDetails?.emirateId)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">{t("city")}</label>
                <input
                  type="text"
                  disabled={true}
                  id="city"
                  name="city"
                  onChange={handleChange}
                  value={getCity(buildingDetails?.cityId)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="serviceTerritory">
                  {t("serviceTerritory")}
                </label>
                <input
                  type="text"
                  disabled={true}
                  id="serviceTerritory"
                  onChange={handleChange}
                  name="serviceTerritory"
                  value={getServiceTerritory(
                    buildingDetails?.serviceTerritoryId
                  )}
                />
              </div>
            </div>
          </div>
          <FooterActions
            buildingDetails={buildingDetails}
            current={"details"}
            previous={"assign"}
            nextPage={"buildingContract"}
          ></FooterActions>
        </div>
      </div>
    </>
  );
};

export default Details;
